import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';

import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';
import { MetalTypeEnum, ProjectAccStatusEnum } from '~utils/enums';
import UtilFunctions from '~utils/functions';
import ProjectGateway from '~apis/project';

export default function* watchGetProjectListing(api: ProjectGateway): SagaWatcherReturnType {
    yield takeEvery('project/projectGetProjectListingAttempt', handleGetProjectListing, api);
}

function* handleGetProjectListing(api: ProjectGateway) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const { index, filters: { status, projectName, dateFrom, dateTo, metalType } } = reduxState.project.projectListing;

    const convertedStatus = UtilFunctions.Misc.getEnumValueByKey(ProjectAccStatusEnum, status);

    if (!index && index !== 0) {
        yield put(combinedActions.projectGetProjectListingFailure(ErrorMessages.GenericRequiredFieldNotFilledIn));
        toast.error(ErrorMessages.GenericRequiredFieldNotFilledIn);
        return;
    }

    // if status is passed but not a valid status
    if (status && !convertedStatus) {
        yield put(combinedActions.projectGetProjectListingFailure(ErrorMessages.FilterInvalidStatusError));
        toast.error(ErrorMessages.FilterInvalidStatusError);
        return;
    }

    const response = yield* call([api, api.getProjectListing], {
        authToken,
        index,
        status: convertedStatus,
        projectName: projectName || undefined,
        dateFrom: dateFrom || undefined,
        dateTo: dateTo || undefined,
        metalType: metalType ? UtilFunctions.Misc.getEnumValueByKey(MetalTypeEnum, metalType) : undefined,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.projectGetProjectListingFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.projectGetProjectListingSuccess(response.data));
    }
}
